import React, { useState, useEffect } from "react";
import Layout from "../../../components/Layout";
import api from "../../../config/api";
import { useHistory } from "react-router-dom";
import NavbarPreference from "./components/Navbar";
import AddPreference from "./components/AddPreference";
import PreferenceTable from "./components/PreferenceTable";

function Preference(props) {
  const [preferences, setPreferences] = useState([]);
  const [categories, setCategories] = useState([]);
  const [categorySelected, setCategorySelected] = useState(() => categories[0]?._id);
  const history = useHistory();

  const handleBack = () => {
    history.goBack();
  };

  async function getPreferences(categorySelected) {
    try {
      const response = await api.get(`preferences/${categorySelected}`);
      setPreferences(response.data);
      setCategorySelected(categorySelected);
    } catch (e) {
      console.error("ERROR GET PREFERENCES: ", e);
    }
  }

  async function getCategory() {
    try {
      await api.get(`category`).then((resp) => {
        setCategories(resp.data.reverse());
      });
    } catch (e) {
      console.error("ERROR GET CATEGORY: ", e);
    }
  }

  useEffect(() => {
    setCategorySelected(() => categories[0]?._id);
  }, [categories]);

  useEffect(() => {
    getCategory();
  }, []);

  useEffect(() => {
    getPreferences(categorySelected);
  }, [categorySelected]);

  return (
    <>
      <Layout buttonClick={handleBack} defaultMenu={5} title={"Preferencias"} link={""}>
        <div className="col-lg d-flex fd-column">
          <div className="col-lg d-flex">
            <NavbarPreference
              appearance="subtle"
              active={categorySelected}
              onSelect={setCategorySelected}
              categories={categories}
            />
          </div>
          {categorySelected ? (
            <>
              <AddPreference {...{ categorySelected, preferences, getPreferences }} />
              <PreferenceTable {...{ preferences, getPreferences, categorySelected }} />
            </>
          ) : (
            <></>
          )}
        </div>
      </Layout>
    </>
  );
}

export default Preference;
